import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import PostPet from './pages/PostPet';
import LostPets from './pages/LostPets';
import FoundPets from './pages/FoundPets';
import PetDetail from './pages/PetDetail';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AdminPanel from './pages/AdminPanel';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/post-pet" element={<ProtectedRoute><PostPet /></ProtectedRoute>} />
          <Route path="/edit-pet/:petId" element={<ProtectedRoute><PostPet /></ProtectedRoute>} />
          <Route path="/lost-pets" element={<LostPets />} />
          <Route path="/found-pets" element={<FoundPets />} />
          <Route path="/pet/:petId" element={<PetDetail />} />
          <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
